import { render } from "./ParentSearchpage.vue?vue&type=template&id=17d69a0a"
import script from "./ParentSearchpage.vue?vue&type=script&lang=js"
export * from "./ParentSearchpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__